const API_ENDPOINTS = {
  CREATE_USER_PREFERENCES: () => "/preferences",
  UPDATE_USER_PREFERENCES: () => "/preferences",
  DELETE_PREFERENCE: id => `/preferences/${id}`,

  CREATE_CLINICIAN: () => "/clinicians",
  UPDATE_CLINICIAN: id => `/clinicians/${id}`,
  COMPLETE_ONBOARDING: id => `/clinicians/${id}/onboarding/complete`,

  CREATE_PATIENT: () => "/patients",
  UPDATE_PATIENT: id => `/patients/${id}`,
  DELETE_PATIENT: id => `/patients/${id}`,

  CREATE_SPINESIM_STUDY: () => "/spinesimstudies",
  UPDATE_SPINESIM_STUDY: id => `/spinesimstudies/${id}`,
  DELETE_SPINESIM_STUDY: id => `/spinesimstudies/${id}`,

  CREATE_DIGITAL_TWIN: () => "/digitaltwins",
  UPDATE_DIGITAL_TWIN: id => `/digitaltwins/${id}`,
  DELETE_DIGITAL_TWIN: id => `/digitaltwins/${id}`,
  PREPARE_REPORT: id => `/digitaltwins/${id}/prepare_report`,
  GENERATE_REPORT: id => `/digitaltwins/${id}/generate_report`,
  GET_PATIENT_REPORTS_LIST: patientId => `/reports/${patientId}`,
  GET_PATIENT_REPORT: (patientId, filename) =>
    `/reports/${patientId}/${filename}`,
  DELETE_REPORT: (patientId, filename) => `/reports/${patientId}/${filename}`,

  CREATE_PAIN_ASSESSMENT: () => "/painassessments",
  UPDATE_PAIN_ASSESSMENT: id => `/painassessments/${id}`,
  DELETE_PAIN_ASSESSMENT: id => `/painassessments/${id}`,

  CREATE_PLAN: () => "/plans",
  DELETE_PLAN: id => `/plans/${id}`,
  COPY_PLAN: id => `/plans/${id}/copy`,

  CREATE_ANNOTATIONS: () => `/annotations`,
  UPDATE_ANNOTATIONS: id => `/annotations/${id}`,
  DELETE_ANNOTATION: id => `/annotations/${id}`,
  DELETE_ANNOTATIONS: instanceId => `/annotations/instance/${instanceId}`,
  SANITY_CHECK_ANNOTATIONS: () => `/annotations/sanity-check`,

  DELETE_INSTANCE: id => `/instances/${id}`,
  VALIDATE_INSTANCE: id => `/instances/${id}/validate`,
  UNVALIDATE_INSTANCE: id => `/instances/${id}/unvalidate`,
  UPDATE_INSTANCE: id => `/instances/${id}`,
  RERUN_LANDMARKING: instanceId => `/instances/${instanceId}/rerun-landmarking`,
  UPLOAD_INSTANCE: patientId => `/instances/${patientId}`,
  PROCESS_INSTANCE: patientId => `/instances/${patientId}/process`,
  GET_INSTANCE_THUMBNAIL: (patientId, instanceId) =>
    `/instances/${patientId}/${instanceId}/thumbnail`,

  CREATE_CUSTOM_MEASUREMENT: () => "/measurements/custom",
  DELETE_CUSTOM_MEASUREMENT: id => `/measurements/custom/${id}`,
  UPDATE_CUSTOM_MEASUREMENT: id => `/measurements/custom/${id}`,

  // Measurements endpoints
  CREATE_MEASUREMENTS: () => "/measurements",
  UPDATE_MEASUREMENTS: () => "/measurements",
  DELETE_MEASUREMENT: id => `/measurements/${id}`,
  CREATE_CURRENT_MEASUREMENTS: () => "/measurements/current",
  UPDATE_CURRENT_MEASUREMENTS: () => "/measurements/current",
  CREATE_TARGET_MEASUREMENTS: () => "/measurements/target",
  UPDATE_TARGET_MEASUREMENTS: () => "/measurements/target",

  CREATE_SURGICAL_ACT: () => "/surgicalacts",
  UPDATE_SURGICAL_ACT: id => `/surgicalacts/${id}`,
  DELETE_SURGICAL_ACT: id => `/surgicalacts/${id}`,

  CREATE_RADIODENSITY_MEASUREMENT: () => "/radiodensitymeasurements",
  UPDATE_RADIODENSITY_MEASUREMENT: id => `/radiodensitymeasurements/${id}`,
  DELETE_RADIODENSITY_MEASUREMENT: id => `/radiodensitymeasurements/${id}`,

  GET_PATIENT_PROFILE_PICTURE: patientId => `/profilepictures/${patientId}`,
  POST_PATIENT_PROFILE_PICTURE: patientId => `/profilepictures/${patientId}`,
  GET_PATIENT_MORPHOLOGY_PICTURES_LIST: patientId =>
    `/morphologyimages/${patientId}`,
  GET_PATIENT_MORPHOLOGY_PICTURE: (patientId, filename) =>
    `/morphologyimages/${patientId}/${filename}`,
  POST_PATIENT_MORPHOLOGY_PICTURE: (patientId, filename) =>
    `/morphologyimages/${patientId}/${filename}`,
  DELETE_MORPHOLOGY_IMAGE: (patientId, filename) =>
    `/morphologyimages/${patientId}/${filename}`,
  POST_DIGITAL_TWIN_ANNEXE_IMAGE: (patientId, digitalTwinId) =>
    `/annexeimages/${patientId}/${digitalTwinId}`,

  CREATE_USER: () => "/users",
  SEND_SUPPORT_EMAIL: () => "/support/sendmail",
  UPDATE_USER: id => `/users/${id}`,
  DELETE_USER: id => `/users/${id}`,

  DELETE_STUDY: id => `/studies/${id}`,
  DELETE_SERIES: id => `/series/${id}`,

  CREATE_CLINICAL_HISTORY: () => "/clinicalhistories",
  UPDATE_CLINICAL_HISTORY: id => `/clinicalhistories/${id}`,
  DELETE_CLINICAL_HISTORY: id => `/clinicalhistories/${id}`,

  CREATE_QUALITY_OF_LIFE_INDICATOR_CONFIG: () =>
    "/qualityoflifeindicatorconfigs",
  UPDATE_QUALITY_OF_LIFE_INDICATOR_CONFIG: id =>
    `/qualityoflifeindicatorconfigs/${id}`,
  DELETE_QUALITY_OF_LIFE_INDICATOR_CONFIG: id =>
    `/qualityoflifeindicatorconfigs/${id}`,
  CREATE_CUSTOM_QUALITY_OF_LIFE_INDICATOR_CONFIG: () =>
    "/qualityoflifeindicatorconfigs/custom",
  UPDATE_CUSTOM_QUALITY_OF_LIFE_INDICATOR_CONFIG: id =>
    `/qualityoflifeindicatorconfigs/custom/${id}`,
  DELETE_CUSTOM_QUALITY_OF_LIFE_INDICATOR_CONFIG: id =>
    `/qualityoflifeindicatorconfigs/custom/${id}`,
};

export default API_ENDPOINTS;
